export default "__VITE_ASSET__Bd5N2jbi__"